import { atom, reatomAsync } from "@reatom/framework";
import { CreateUploadInterface, UploadFileToSessionInterface } from "./types";
import {
  createUploadFile,
  deleteFileToSession,
  DeleteFileToSessionBodyInterface,
  uploadFileToSession,
  UploadFileToSessionBodyInterface,
} from "@/core/api/requests/upload";

export const uploadSessionAtom = atom<CreateUploadInterface | null>(
  null,
  "uploadSessionAtom"
);

export const uploadSessionAction = reatomAsync(
  async (ctx, oid: string) => ctx.schedule(() => createUploadFile({ oid })),
  {
    name: "uploadSessionAction",
    onFulfill: (_ctx, data) => {
      uploadSessionAtom(_ctx, data);
    },
    onReject: (_ctx, error) => {
      console.error(error);
    },
  }
);

export const uploadFileToSessionAtom =
  atom<UploadFileToSessionInterface | null>(null, "uploadFileToSessionAtom");

export const uploadFileToSessionAction = reatomAsync(
  async (ctx, body: UploadFileToSessionBodyInterface) =>
    ctx.schedule(() => uploadFileToSession(body)),
  {
    name: "uploadFileToSessionAction",
    onFulfill: (_ctx, data) => {
      const prevData = _ctx.get(uploadFileToSessionAtom);

      uploadFileToSessionAtom(
        _ctx,
        prevData?.items.length
          ? { ...prevData, items: [...prevData.items, ...data.items] }
          : data
      );
    },
    onReject: (_ctx, error) => {
      console.error(error);
    },
  }
);

export const deleteFileToSessionAction = reatomAsync(
  async (ctx, body: DeleteFileToSessionBodyInterface) => {
    const prev = ctx.get(uploadFileToSessionAtom);
    if (prev) {
      uploadFileToSessionAtom(ctx, {
        session_id: prev?.session_id,
        items: prev.items.filter((item) => item.id !== body.files.id),
      });
    }
    const response = await ctx.schedule(() => deleteFileToSession(body));

    return response;
  },
  {
    name: "uploadFileToSessionAction",
    onFulfill: (_ctx, data) => {
      const prev = _ctx.get(uploadFileToSessionAtom);
      if (!prev) {
        return;
      }
      uploadFileToSessionAtom(_ctx, {
        session_id: prev?.session_id,
        items: data.files,
      });
    },
    onReject: (_ctx, error) => {
      console.error(error);
    },
  }
);
